export default {"src":"/_next/static/media/dots.e90f0bf2.svg","height":225,"width":245,"blurWidth":0,"blurHeight":0};